export default __webpack_public_path__ + "static/11-6f7854a7840246b850bb5a4bdd6f4d02.jpg";